export const APPLE_STORE_URL = 'https://apps.apple.com/au/app/aem/id1607457067';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.aem.plus&pcampaignid=web_share';
export const JOURNALER_URL = 'https://journaler.aem.ac/';
export const TELEGRAM_URL = 'https://t.me/MrJournaler';
export const MR_JOURNALER_PATH = '/journaler/mrJournaler';
